import React, { useCallback, useEffect } from "react";
import { Layout, Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import routesInit, { ICustomRouterConfig } from "@/routers";
import { EActionType, UserInfo } from "@/store/globle/types";
import { IState } from "@/store";
import getMenu from "@/api/menu";
import logo from "@/assets/img/logo.png";
import UserInfoArea from "@/components/Layout/components/UserInfoArea";
import LayoutAuthority from "@/components/Layout/components/LayoutAuthority";
import LayoutNoAuthority from "@/components/Layout/components/LayoutNoAuthority";
import "./index.less";
const { Header } = Layout;

const Home: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const loading = useSelector<IState, boolean>((state) => state.globle.loading);
  const routes = useSelector<IState, ICustomRouterConfig[]>(
    (state) => state.globle.routes
  );
  const noAuthority = useSelector<IState, boolean>(
    (state) => state.globle.noAuthority
  );
  const userInfo = useSelector<IState, UserInfo>(
    (state) => state.globle.userInfo
  );
  // 初始化路由
  const initRoutes = useCallback(async () => {
    const res = await getMenu({ workcode: userInfo.workcode });
    // res.data.detail_menu = []; //模拟无权限
    const allRoutes = await routesInit(res.data);
    dispatch({ type: EActionType.SET_ROUTES, routes: allRoutes });
    if (!res.data?.detail_menu.length) {
      dispatch({ type: EActionType.NO_AUTHORITY, noAuthority: true });
    } else {
      dispatch({ type: EActionType.NO_AUTHORITY, noAuthority: false });
    }
  }, []);

  //匹配当前path是否在路由表中存在
  const redirectPage = (searchItem, allRoutes, resultArr = []) => {
    for (let i = 0; i < allRoutes.length; i++) {
      if (allRoutes[i].children && allRoutes[i].children.length) {
        redirectPage(searchItem, allRoutes[i].children, resultArr);
      } else {
        if (searchItem.includes(allRoutes[i].path)) {
          resultArr.push(allRoutes[i].path);
        }
      }
    }
    return resultArr;
  };

  //用户输入错误的菜单跳转到默认页面
  const failPathToDefault = () => {
    let arr: Array<string> = [];
    if (routes && routes[0]) {
      arr = redirectPage(location.pathname, routes[0].children, arr);
      if (!arr.length) {
        if (noAuthority) {
          navigate("/noAuthority");
        } else {
          navigate("/landingPage");
        }
      } else {
        navigate(location.pathname + location.search);
      }
    }
  };
  useEffect(() => {
    initRoutes(); //初始hua路由
  }, []);

  useEffect(() => {
    failPathToDefault(); //防止用户输入错误的地址
  }, [location.pathname, routes]);

  return (
    <Spin spinning={loading} delay={100}>
      <Layout className="layout">
        <Header className="header">
          <div className="left-area">
            <img className="logo" src={logo} alt="logo" />
          </div>
          <UserInfoArea userInfo={userInfo}></UserInfoArea>
        </Header>
        {!noAuthority ? (
          <LayoutAuthority routes={routes}></LayoutAuthority>
        ) : (
          <LayoutNoAuthority routes={routes}></LayoutNoAuthority>
        )}
      </Layout>
    </Spin>
  );
};

export default Home;
